<template>
  <BookingsBase
    ref="bookingsBase"
    user-type="photographer"
    header-button-icon="arrow_back"
    header-button-color="secondary"
    :header-button-label="$t('bookings.goToPhotographers')"
    @header-button-click="goToPhotographers"
  >
    <template #booking-actions="{ booking, handlers }">
      <AppActionButton
        v-if="canCancel(booking.status)"
        type="cancel"
        :label="$t('bookings.dialog.cancel.action')"
        icon="cancel"
        @click="openCancelDialog(booking, handlers)"
      />
      <AppActionButton
        v-if="canComplete(booking.status)"
        type="accept"
        :label="$t('bookings.dialog.complete.action')"
        icon="check_circle"
        @click="openCompleteDialog(booking)"
      />
    </template>
  </BookingsBase>
</template>

<script>
import BookingsBase from '@/pages/bookings/components/BookingsBase.vue';
import AppActionButton from '@/components/AppActionButton.vue';
import { mapActions, mapState } from 'vuex';
import { notifySuccess, notifyError } from '@/utils/notify';

export default {
  name: 'BookingsOrganizer',
  components: { BookingsBase, AppActionButton },
  computed: {
    ...mapState({
      userRole: (state) => state.auth.user?.role,
      wallet: (state) => state.global.wallet,
    }),
    isAuthorizedToModify() {
      return this.userRole === 'organizer' || this.userRole === 'administrator';
    },
  },
  methods: {
    ...mapActions('bookings', ['payoutBooking', 'updateBookingStatus']),
    ...mapActions('global', ['getUserWalletData']),

    async handlePayout(booking, successKey, errorKey) {
      try {
        if (booking.status !== 'completed') {
          throw new Error(errorKey)
        }

        if (this.wallet < booking.rate) {
          throw new Error('bookings.insufficientFunds');
        }

         await this.payoutBooking(booking.id);
         notifySuccess(successKey);
      } catch (error) {
        notifyError(
          error?.message === 'bookings.insufficientFunds'
            ? error.message
            : errorKey
        );
      }
    },
    goToPhotographers() {
      this.$router.push({
        name: 'userPanel',
        query: { tab: 'photographers-list' },
      });
    },
    canCancel(status) {
      const isPendingOrAccepted = status === 'pending' || status === 'accepted';
      return isPendingOrAccepted && this.isAuthorizedToModify;
    },
    canComplete(status) {
      return status === 'accepted' && this.isAuthorizedToModify;
    },
    openCancelDialog(booking, handlers) {
      this.$refs.bookingsBase.openDialog(booking, 'cancel', () =>
        handlers.updateStatus(
          booking.id,
          'cancelled',
          'bookings.dialog.cancel.success',
          'bookings.dialog.cancel.error'
        )
      );
    },
    openCompleteDialog(booking) {
      this.$refs.bookingsBase.openDialog(booking, 'complete', () =>
        this.handlePayout(
          booking,
          'bookings.dialog.complete.success',
          'bookings.dialog.complete.error'
        )
      );
    },
  },
  mounted() {
    this.getUserWalletData();
  },
};
</script>
